import Facebook from 'assets/images/social-media/facebook.png';
import Amazon from 'assets/images/social-media/amazon.png';
import Fetlife from 'assets/images/social-media/fetlife.png';
import Snapchat from 'assets/images/social-media/snapchat.png';
import Twitter from 'assets/images/social-media/twitter.png';
import Instagram from 'assets/images/social-media/instagram.png';
import Discord from 'assets/images/social-media/discord.png';
import Sharesome from 'assets/images/social-media/sharesome.png';
import Telegram from 'assets/images/social-media/telegram.png';
import Youtube from 'assets/images/social-media/youtube.png';
import Onlyfans from 'assets/images/social-media/onlyfans.svg';
import Membersite from 'assets/images/membersite-logo.png';
import { getAmazonPrefix } from 'common/utils/utils';


function useSiteGlobalSettingsHelper(setting){
   const SOCIAL_MEDIAS = {
      social_media_links_my_siteaffilate: { logo: Membersite, domain: 'https://affiliate.mymember.site/' },
      social_media_links_facebook: { logo: Facebook, domain: 'https://www.facebook.com/' },
      social_media_links_instagram: { logo: Instagram, domain: 'https://www.instagram.com/' },
      social_media_links_snapchat: { logo: Snapchat, domain: 'https://www.snapchat.com/add/' },
      social_media_links_twitter: { logo: Twitter, domain: 'https://x.com/' },
      social_media_links_fetlife: { logo: Fetlife, domain: 'https://fetlife.com/' },
      social_media_links_amazon: { logo: Amazon, domain: getAmazonPrefix() },
      social_media_links_discord: { logo: Discord, domain: 'https://discord.com/invite/' },
      social_media_links_sharesome: { logo: Sharesome, domain: 'https://sharesome.com/' },
      social_media_links_youtube: { logo: Youtube, domain: 'https://www.youtube.com/' },
      social_media_links_telegram: { logo: Telegram, domain: 'https://t.me/' },
      social_media_links_onlyfans: { logo: Onlyfans, domain: 'https://www.onlyfans.com/' },
   }

   const getIsDarkMode = () => {
      const colorSettings = getSectionGlobalSetting('color');
      const colorBackground = colorSettings.color_background
      return colorBackground.color === '#000000'
   }
   const getSitePrimaryColor = () => {
      const colorSettings = getSectionGlobalSetting('color');
      let color = '#231FFF';
      Object.keys(colorSettings).forEach(key => {
         const setting = colorSettings[key]
         if(setting.selected){
            color = setting.primary_color;
         }

      });
      return color
   }
   const getSectionGlobalSetting = (type) => {
      return setting[type]
   }
   const getModifySectionGlobalSetting = (type) => {
      const settings = setting?.[type];
      let result = {};
      Object.keys(settings).forEach(key => {
         const value = settings[key];
         const newKey = key.replace(`${ type }_`, '');
         result = {
            ...result,
            [newKey]: value,
         }
      });
      return result;
   }

   const getSiteLogoImage = () => {
      const logoSettings = getSectionGlobalSetting('logo', setting);
      return logoSettings?.logo_type?.image_full_src;
   }

   const generateSocialMediaLink  = (key) => {
      const settings = getSectionGlobalSetting('social_media_links');
      const link = settings?.[key] || {};
      const domain = SOCIAL_MEDIAS?.[key]?.domain;
      let mediaLink = link?.link;
      if(!link.is_custom && domain && link?.nickname){
         mediaLink = domain + link?.nickname;
      }
      return mediaLink;
   }

   const getSocialMediaLinkImage = (key) => {
      const settings = getSectionGlobalSetting('social_media_links');
      const link = settings?.[key] || {};
      if(link?.image_src && link?.image_full_src){
         return link.image_full_src;
      }
      if(!link?.is_custom){
         return SOCIAL_MEDIAS?.[key]?.logo;
      }
      return null
   }
   const getSiteSocialMediaLinks = () => {
      const settings = getSectionGlobalSetting('social_media_links');
      let result = [];
      Object.keys(settings).forEach(key => {
         const linkItem = settings?.[key] || {};
         const link = generateSocialMediaLink(key);
         if(link){
            result = [...result, {
               oreder: linkItem.order,
               link,
               logo: getSocialMediaLinkImage(key),
            }]
         }

      });
      return result.sort((a, b) => {
         return a.oreder > b.oreder ? 1 : -1
      })
   }

   return {
      getSiteLogoImage,
      getSectionGlobalSetting,
      generateSocialMediaLink,
      getSocialMediaLinkImage,
      getSiteSocialMediaLinks,
      getModifySectionGlobalSetting,
      getSitePrimaryColor,
      getIsDarkMode,
   }
}

export {
   useSiteGlobalSettingsHelper,
   // getSectionByPage,
}
